
import { CommonModule } from '@angular/common';
import { Component, inject, input, InputSignal } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'modal-navbar-details',
    imports: [
        CommonModule, 
        TranslateModule,
        IonicModule
    ],
    standalone: true,
    templateUrl: './modal-navbar.component.html',
    styleUrls: ['./modal-navbar.component.scss'],
})

export class ModalNavBarComponent {
    private modalController = inject(ModalController);
    public translate = inject(TranslateService);
    public title: InputSignal<any> = input.required<any>();

    dismissModal() {
        this.modalController.dismiss();
    }

}